import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { forwardRef, ForwardedRef } from "react";

import { MobileTopBar } from "@covertree/layouts";
import { AnimationBox, Covertree, LegalDisclaimer } from "@covertree/ui";

import { DesktopSidebar } from "./DesktopSidebar";
import { Step } from "../types";

interface DeviceLayoutProps<StepPathType> {
  isDesktop: boolean;
  sections: Record<string, string[]>;
  currentStep: Step<StepPathType>;
  contactNumber: string;
  contentWidth: string;
  showDisclaimerMessage: boolean;
  showBackButton: boolean;
  children: React.ReactNode;
}

function DeviceLayoutComponent<StepPathType>(
  {
    isDesktop,
    sections,
    currentStep,
    contactNumber,
    contentWidth,
    showDisclaimerMessage,
    showBackButton,
    children,
  }: DeviceLayoutProps<StepPathType>,
  ref: ForwardedRef<HTMLDivElement>
) {
  return isDesktop ? (
    <Container>
      <Grid container>
        <Grid item md={2}>
          <DesktopSidebar
            contactPhoneNumber={contactNumber}
            sections={sections}
          />
        </Grid>
        <Grid
          ref={ref}
          item
          md={10}
          pt={5}
          pl={3}
          sx={{
            height: "100vh",
            pr: 3,
            overflowY: "scroll",
            "&::-webkit-scrollbar": { display: "none" },
          }}>
          <Box width={contentWidth}>
            <AnimationBox currentStep={currentStep}>
              {children}
              {showDisclaimerMessage && <LegalDisclaimer mt={5} />}
            </AnimationBox>
          </Box>
        </Grid>
      </Grid>
    </Container>
  ) : (
    <>
      <MobileTopBar
        logo={<Covertree height={100} width={86} />}
        showBackButton={showBackButton}
        sidebar={
          <DesktopSidebar
            contactPhoneNumber={contactNumber}
            sections={sections}
          />
        }
      />
      <Container
        sx={{
          paddingTop: 4,
          paddingX: { xs: 2 },
          paddingBottom: 12,
        }}>
        <Grid
          container
          p={0}
          sx={{ flex: 1, display: { xs: "block", md: "flex" } }}>
          {children}
        </Grid>
        {showDisclaimerMessage && <LegalDisclaimer mt={5} />}
      </Container>
    </>
  );
}

export const DeviceLayout = forwardRef(DeviceLayoutComponent);
